import { getHomePageDetail } from "../../../redux/actions/HomeAction";
import { addDocTypeRowAction } from "../../../redux/actions/ProfileVerificationAction";
import {
  deleteFileAction,
  deletePermanentFileAction,
} from "../../../redux/actions/GlobalAction";
import {
  getChainId,
  getProviderPortalId,
  getProviderPortalRole,
} from "../../../Utils/types";

export const removeImageHandler = async (
  docDetails,
  getPageAPI,
  isRowDelete,
  dispatch
) => {
  docDetails?.isVerified
    ? await dispatch(
        deletePermanentFileAction(docDetails?.providerImageId, isRowDelete)
      )
    : await dispatch(
        deleteFileAction(docDetails?.providerImageStgId, isRowDelete)
      );
  await dispatch(getPageAPI());
};

export const deletePermanentImageHandler = async (
  providerImageId,
  accreditationName,
  callPageAPI,
  dispatch
) => {
  await dispatch(deletePermanentFileAction(providerImageId, true));
  await dispatch(addDocTypeRowAction(accreditationName));
  await dispatch(callPageAPI());
};

export const deleteStagingImageHandler = async (
  providerImageId,
  isRowDelete,
  callPageAPI,
  dispatch
) => {
  await dispatch(deleteFileAction(providerImageId, isRowDelete));
  await dispatch(callPageAPI());
};

export const callHomePageAPI = async (dispatch) => {
  dispatch(
    getHomePageDetail(
      getProviderPortalId(),
      getChainId(),
      getProviderPortalRole()
    )
  );
};
